import _mixpanel from "mixpanel-browser"

const init = () => {
  /**
   * We only use mixpanel-browser for tracking page views,
   * the rest of the tracking happens on the server
   *
   */
  if (process.env.NEXT_PUBLIC_MIXPANEL_KEY) {
    _mixpanel.init(process.env.NEXT_PUBLIC_MIXPANEL_KEY, {
      track_pageview: false,
    })
    return _mixpanel
  }
}

export default init
